import { connect } from 'react-redux'
import { compose } from 'redux'
import LayiPage from '../components/LayiPage'
import { canUseLayi } from '../selectors/users'
import { getLocale } from '../selectors/i18n'
import { withTranslator } from '../components/HOCComponents/withTranslator'

const mapStateToProps = state => ({
  canUseLayi: canUseLayi(state),
  locale: getLocale(state)
})

export default compose(withTranslator, connect(mapStateToProps))(LayiPage)
